import { useRestoreAgentConfiguration } from "@app/lib/swr/assistants";
import type { LightAgentConfigurationType } from "@app/types/assistant/agent";
import type { LightWorkspaceType } from "@app/types/user";
import {
  Dialog,
  DialogContainer,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@dust-tt/sparkle";
import { useTranslation } from "react-i18next";

interface RestoreAssistantDialogProps {
  agentConfiguration?: LightAgentConfigurationType;
  isOpen: boolean;
  isPrivateAssistant?: boolean;
  onClose: () => void;
  owner: LightWorkspaceType;
}

export function RestoreAgentDialog({
  agentConfiguration,
  isOpen,
  onClose,
  owner,
}: RestoreAssistantDialogProps) {
  const { t } = useTranslation();
  const doRestore = useRestoreAgentConfiguration({ owner, agentConfiguration });

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent size="md" isAlertDialog>
        <DialogHeader hideButton>
          <DialogTitle>
            {t("assistant.restoringTheAgent", "Restoring the agent")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "common.restoreAgentForEveryone",
              "This will restore the agent for everyone."
            )}
          </DialogDescription>
        </DialogHeader>
        <DialogContainer>
          <div className="font-bold">
            {t(
              "common.sureYouWantToProceed",
              "Are you sure you want to proceed?"
            )}
          </div>
        </DialogContainer>
        <DialogFooter
          leftButtonProps={{
            label: t("assistant.cancel", "Cancel"),
            variant: "outline",
          }}
          rightButtonProps={{
            label: t("assistant.restoreTheAgent", "Restore the agent"),
            variant: "warning",
            onClick: async () => {
              await doRestore();
              onClose();
            },
          }}
        />
      </DialogContent>
    </Dialog>
  );
}
